import { Component, OnInit, Input } from '@angular/core';
import { Ring } from '../../billboard.interface';

@Component({
	selector: 'eze-ring',
	templateUrl: './ring.component.html',
	styleUrls: ['./ring.component.css']
})
export class RingComponent implements OnInit {
	@Input() index = 0;
	@Input() totalInColumn = 6;
	@Input() ring: Ring = null;

	get percentHeight(): number {
		return (1 / this.totalInColumn) * 100;
	}

	get ringHeight(): string {
		const percent = this.percentHeight;
		return percent.toString() + 'vh';
	}

	get ringTitleSize(): string {
		const percent = this.percentHeight * 0.33;
		return percent.toString() + 'vh';
	}

	get groupFontSize(): string {
		const percent = this.percentHeight * 0.2;
		return percent.toString() + 'vh';
	}

	constructor() {}

	ngOnInit() {}
}
